<!-- eslint-disable vue/no-v-html -->
<template>
  <div>
    <div class="progress-container">
      <div class="m-medium-top" />
      <div class="p-medium">
        <p
          v-if="regType !== 'iStock'"
          class="tertiary-link xsmall top-margin-zero"
        >
          <a
            id="question-overlay-modal-trigger"
            href="javascript:void(0)"
          >
            {{ questionsLink }}</a>
        </p>
        <ModalComponent
          v-if="regType !== 'iStock'"
          :modal-header="questionsModalHeader"
          :modal-body1="questionsModalBody1"
          :modal-link-url="pageLinkUrl"
          :modal-link-val="questionsChatWithRep"
          body-class="xlarge m-xxsmall-top"
          modal-class="xsmall"
          id-val="question-overlay-modal"
          @exitmodal-action="openChatWindow"
        />
      </div>
    </div>
    <div v-if="isManagedAccount">
      <PageHeading :default-heading="managedReturnToProposalHeader" />
      <div class="pvd-container container-divider">
        <p>
          {{ managedReturnToProposalBody }}
        </p>
        <p>
          <a
            :href="managedReturntoGoalProposalUrl"
            v-html="gbpLinkText"
          />
        </p>
        <p>
          <a
            :href="managedReturntoDifsProposalUrl"
            v-html="difsLinkText"
          />
        </p>
        <p>
          <a
            :href="managedReturntoMaccProposalUrl"
            v-html="maccLinkText"
          />
        </p>
      </div>
    </div>
    <div v-else>
      <PageHeading :default-heading="pageHeader" />
      <div class="pvd-container container-divider">
        <p>
          {{ pageText }}
          <a
            v-if="regType !== 'iStock'"
            class="pvd-anchor"
            href="#"
            @click.prevent="openChatWindow()"
          >
            {{ pageLinkText }}
          </a>
        </p>
        <p v-if="regType === 'iStock'">
          <a
            :href="pageLinkUrl"
            v-html="pageLinkText"
          />
        </p>
      </div>
      <div
        v-if="regType !== 'iStock'"
        class="pvd-container pvd-btn-row"
      >
        <div
          v-if="!isMaestro() && !isLiteView()"
          class="button-group"
        >
          <button
            class="pvd-btn btn-action"
            @click.prevent="handleUrlClick(modalUrl)"
          >
            {{ startApplication }}
          </button>
        </div>
        <div
          v-if="!isMaestro() && !isLiteView()"
          class="tertiary-link xsmall"
        >
          <a
            id="exit-overlay-modal-trigger"
            href="javascript:void(0)"
          >
            {{ modalExitVal }}
          </a>
        </div>
      </div>
      <ModalComponent
        v-if="regType !== 'iStock'"
        :modal-header="modalHeader"
        :modal-body1="modalBody1"
        :modal-body2="modalBody2"
        :modal-footer="modalFooter"
        :modal-btn-url="modalUrl"
        :modal-btn-val="modalVal"
        id-val="exit-overlay-modal"
        @close-action="closeModal"
        @exitmodal-action="handleUrlClick"
      />
    </div>
  </div>
</template>

<script>
import PageHeading from '../components/PageHeading.vue';
import ModalComponent from '../components/ModalComponent.vue';
import dataHelper from '../mixins/dataHelper';
import measurement from '../mixins/measurement';
import utility from '../mixins/utility';
import constants from '../mixins/constants';

export default {
  name: 'SystemError',
  components: {
    PageHeading,
    ModalComponent,
  },
  mixins: [dataHelper, measurement, utility],
  data() {
    return {
      backButtonAttempt: false,
      regType: '',
    };
  },
  computed: {
    pageHeader() {
      return this.pd_content.system_error_page_header || constants.SOMETHING_WENT_WRONG;
    },
    managedReturnToProposalHeader() {
      return this.pd_content.system_error_managed.header;
    },
    managedReturnToProposalBody() {
      return this.pd_content.system_error_managed.body;
    },
    pageText() {
      let returntext;
      if (this.regType === 'iStock') {
        returntext = this.pd_content.system_error_text || constants.WERE_SORRY;
      } else {
        returntext = this.pd_content.system_error_text || constants.WERE_SORRY_WITH_NUMBER;
      }
      return returntext;
    },
    pageLinkText() {
      // ToDo: extend this to work with other regtypes
      let text;
      if (this.regType === 'iStock') {
        text = constants.RETURN_TO_NETBENEFITS;
      } else {
        text = constants.CHAT_WITH_REP;
      }
      return this.pd_content.system_error_link ? this.pd_content.system_error_link.value : text;
    },
    pageLinkUrl() {
      let text;
      if (this.regType === 'iStock') {
        text = constants.NETBENEFITS_URL;
      } else {
        text = constants.CHAT_URL;
      }
      return this.pd_content.system_error_link ? this.pd_content.system_error_link.url : text;
    },
    modalHeader() {
      return this.pd_content.exit_overlay_modal_header || constants.MODAL_HEADER;
    },
    modalBody1() {
      return this.pd_content.exit_overlay_modal_body1 || constants.MODAL_BODY1;
    },
    modalBody2() {
      return this.pd_content.exit_overlay_modal_body2 || constants.MODAL_BODY2;
    },
    modalFooter() {
      return this.pd_content.exit_overlay_modal_footer || constants.MODAL_FOOTER;
    },
    modalUrl() {
      let returnVal;
      if (this.$globalData.tStoreResponse && this.$globalData.tStoreResponse.exitURL) {
        if (this.$globalData.tStoreResponse.exitURL.method === 'POST') {
          returnVal = { url: this.$globalData.tStoreResponse.exitURL.url, method: 'POST' };
        } else {
          returnVal = this.$globalData.tStoreResponse.exitURL.url;
        }
      } else {
        returnVal = this.pd_content.overlay_exit_link ? this.pd_content.overlay_exit_link.all_accounts_url
          : constants.OVERLAY_EXIT_URL_LINK;
      }
      return returnVal;
    },
    modalVal() {
      return this.pd_content.overlay_exit_link ? this.pd_content.overlay_exit_link.value
        : constants.OVERLAY_EXIT_LINK_VAL;
    },
    modalExitVal() {
      return this.pd_content.exit_link ? this.pd_content.exit_link.value : constants.EXIT;
    },
    startApplication() {
      return this.pd_content.start_application_text || constants.START_NEW_APPLICATION;
    },
    questionsLink() {
      return this.pd_content.questions_link || constants.QUESTIONS_LINK;
    },
    questionsModalHeader() {
      return this.pd_content.question_overlay_modal_header || constants.QUESTIONS_MODAL_HEADER;
    },
    questionsModalBody1() {
      return this.pd_content.question_overlay_modal_body1 || constants.QUESTIONS_MODAL_BODY1;
    },
    questionsChatWithRep() {
      return this.pd_content.rep_chat_link || constants.QUESTIONS_CHAT_WITH_REP;
    },
    isManagedAccount() {
      return this.isManaged(this.routeId);
    },
    gbpLinkText() {
      return this.pd_content.system_error_managed_exit_link.gbp_link_text;
    },
    difsLinkText() {
      return this.pd_content.system_error_managed_exit_link.difs_link_text;
    },
    maccLinkText() {
      return this.pd_content.system_error_managed_exit_link.macc_link_text;
    },
    managedReturntoGoalProposalUrl() {
      return this.pd_content.system_error_managed_exit_link.gbp_url;
    },
    managedReturntoDifsProposalUrl() {
      return this.pd_content.system_error_managed_exit_link.difs_url;
    },
    managedReturntoMaccProposalUrl() {
      return this.pd_content.system_error_managed_exit_link.macc_url;
    },
  },
  mounted() {
    this.configureBackButtonFunctionality(() => this.showBackWarning(
      this.backButtonWarning(document.location.pathname),
    ));
    this.track('system-error', 'pageview');
    document.title = this.setTitle(this.pageHeader);
    this.resetFormData();
    this.regType = this.getRegType(document.location.pathname);
  },
  methods: {
    backButtonWarning(url) {
      const reg = this.getRegType(url);
      if (constants.ROLLOVERIRA_REGTYPE === reg) {
        return this.pd_content.back_button_disabled_warning || constants.BACK_BUTTON_WARNING;
      }
      return this.pd_content.back_button_disabled_warning;
    },
    openChatWindow() {
      this.track('rep-chat-link', 'interaction');
      const url = this.pd_content.system_error_link ? this.pd_content.system_error_link.url
        : constants.CHAT_URL;
      document
        .querySelector('#question-overlay-modal')
        .setAttribute('active', 'false');
      this.openWindow(url, 'documentwindow', '650', '650');
    },
    closeModal() {
      document
        .querySelector('#exit-overlay-modal')
        .setAttribute('active', 'false');
    },
    handleUrlClick(url) {
      this.track('overlay_exit_link', 'interaction');
      if (typeof url === 'object') {
        this.submitForm(
          this.createForm(url.url, (
            this.$globalData.tStoreResponse && this.$globalData.tStoreResponse.params) ? this.$globalData.tStoreResponse.params : ''),
        );
      } else {
        window.location.assign(url);
      }
    },
  },
};
</script>

<style scoped>
    body {
        padding: 0 !important;
    }
</style>
